import React from "react";
import { CLIENTS } from "../data/clients";

const ClientGrid = () => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
      {CLIENTS.map((client, index) => (
        <div
          key={`${client.name}-${index}`}
          className="bg-white rounded-lg p-6 flex items-center justify-center h-28 hover:shadow-xl transition-all duration-300 hover:scale-105 group cursor-pointer"
        >
          {client.logo ? (
            <img
              src={client.logo}
              alt={client.name}
              className="object-contain w-[95%] h-[95%]"
            />
          ) : (
            <div className="text-center">
              <div className="text-sm font-bold text-gray-800 leading-tight line-clamp-3 group-hover:text-[#c9923f] transition-colors">
                {client.name}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ClientGrid;
